import DateTimePicker from "react-datetime-picker";
import { ShipmentStatusModel } from "../apiModels/shipmentStatusModel";
import { Value } from "react-datetime-picker/dist/cjs/shared/types";

export default function ShipmentUpdateCreateEditForm(props: {
    description: string,
    setDescription: (description: string) => void,
    location: string,
    setLocation: (location: string) => void,
    statusId: number,
    setStatusId: (statusId: number) => void,
    updateTime: Value,
    setUpdateTime: (updateTime: Value) => void,
    statuses: ShipmentStatusModel[]
}) {
    return (<>
        <div className="row">
            <div className="col-12">
                <label htmlFor="description" className="fw-bold">Description</label>
                <input className="form-control" name="description" placeholder="Description" required={true} maxLength={500} value={props.description} onChange={(e) => props.setDescription(e.target.value)} />
            </div>
        </div>

        <div className="row">
            <div className="col-12">
                <label htmlFor="location" className="fw-bold">Location</label>
                <input className="form-control" name="location" placeholder="Location" maxLength={500} value={props.location} onChange={(e) => props.setLocation(e.target.value)} />
            </div>
        </div>

        <div className="row">
            <div className="col-12">
                <label className="fw-bold">Status</label>
                <select className="form-control" value={props.statusId} onChange={(e) => props.setStatusId(parseInt(e.target.value))}>
                    {props.statuses.map((status) => {
                        return <option key={status.id} value={status.id}>{status.name}</option>
                    })}
                </select>
            </div>
        </div>

        <div className="row">
            <div className="col-12">
                <label htmlFor="date" className="fw-bold">Date</label>
                <DateTimePicker className="form-control" name="date" value={props.updateTime} onChange={(d) => props.setUpdateTime(d)} />
            </div>
        </div>
    </>);
}